import createLucideIcon from '../createLucideIcon';

const ArrowUpLeft = createLucideIcon('ArrowUpLeftIcon', [
  ['line', { x1: '17', y1: '17', x2: '7', y2: '7', key: '814yaz' }],
  ['polyline', { points: '7 17 7 7 17 7', key: '1jae2c' }],
]);

export default ArrowUpLeft;
